import type { Theme } from '@/stores/theme-store';

type DocumentWithViewTransition = Document & {
  startViewTransition?: (callback: () => void) => unknown;
};

export const applyThemeToDocument = (theme: Theme) => {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  root.classList.toggle('dark', theme === 'dark');
};

export const setThemeWithTransition = (
  theme: Theme,
  setTheme: (theme: Theme) => void,
) => {
  const doc = document as DocumentWithViewTransition;
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  if (!doc.startViewTransition || prefersReducedMotion) {
    setTheme(theme);
    return;
  }

  doc.startViewTransition(() => {
    applyThemeToDocument(theme);
    setTheme(theme);
  });
};
